'use strict';

const MotionGlobalConfig = {};

exports.MotionGlobalConfig = MotionGlobalConfig;
//# sourceMappingURL=global-config.cjs.map
